import React from 'react'

const PlantDetail = () => {
  return (
    <div>PlantDetail</div>
  )
}

export default PlantDetail